import { makeStyles } from "@mui/styles";
import tinycolor from "tinycolor2";

export default makeStyles((theme) => ({
  uploadbutton: {
    backgroundColor: "#CB1A14",
    width: 120,
    height: 39,
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 500,
    gap: 5,
    color: "white",
    position: "relative",
    zIndex: 50,
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  rightcont: {
    position: "relative",
    backgroundColor: "white",
    height: "calc(100vh - 300px)",
    boxSizing: "border-box",
    padding: "24px 15px 0px 15px",
    overflow: "scroll"
  },
  exportbtn: {
    // maxWidth: "190px",
    // position: "absolute",
    position: "sticky",
    bottom: "0px",
    left: "18px",
    right: "19px",
    margin: "0 auto"
  },
  buttons: {
    maxWidth: "300px",
    margin: "18px auto"
  },
  savebtn: {
    maxWidth: "150px",
    margin: "18px auto"
  },
  notedetails: {
    height: "100%",
    overflow: "scroll",
    "& h4": {
      fontWeight: "700",
      marginBlock: "0px",
      fontSize: "14px",
      color: "black",
      textAlign: "left"
    },
    "& h5": {
      fontWeight: "700",
      marginBlock: "0px",
      fontSize: "11.33px",
      color: "#6C737F",
      textAlign: "left"
    },
    "& p": {
      fontWeight: 400,
      fontSize: "9.71px",
      color: "#6C737F",
      marginBlock: "0px",
      textAlign: "left"
    },
    "@media (max-width: 900px)": {
      height: "100%"
    }
  },
  notespan: {
    marginTop: "10px",
    marginBottom: "10px",
    "& h5": {
      fontWeight: "700",
      marginBlock: "0px",
      fontSize: "15px",
      color: "#6C737F",
      textAlign: "left"
    },
    "& p": {
      fontWeight: 400,
      fontSize: "12px",
      color: "#6C737F",
      marginBlock: "0px",
      textAlign: "left"
    }
  },
  textarea: {
    border: "none",
    height: "70px",
    width: "100%"
  },
  fortextarea: {
    // padding: "16px",
    borderRadius: "9px",
    left: "18px",
    right: "19px",
    margin: "5 auto",
    position: "sticky",
    bottom: "0px"
  },
  commentarea: {
    textAlign: "left",
    padding: "16px",
    border: "1px solid #F0F2F5",
    fontSize: "14px"
  },
  verticalline: {
    paddingLeft: 15,
    paddingBottom: 5,
    textAlign: "left"
  },
  parsercont: {
    textAlign: "left",
    "& ul": {
      listStyle: "initial",
      paddingLeft: "24px"
    }
  },
  overallcont: {
    paddingLeft: "11px",
    cursor: "pointer",
    "& h3": {
      fontWeight: "500",
      fontSize: "18px",
      letterSpacing: "-0.3px",
      marginBlock: "0px",
      textAlign: "left",
      textDecoration: "none"
    },
    "& hr": {
      width: "90%",
      border: "0.1px solid #BAC1CC",
      float: "left",
      marginBlock: "26px 18px"
    }
  },
  cardcontent: {
    textAlign: "left",
    fontSize: "14px",
    maxHeight: "70px",
    overflow: "hidden",
    "& h1": {
      fontSize: "14px",
      fontWeight: 400,
      textAlign: "left",
      marginBlock: "0px"
    },
    "& p": {
      fontSize: "14px",
      fontWeight: 400,
      color: "#667185",
      textAlign: "left",
      marginBlock: "0px"
    },
    "& h3": {
      fontSize: "14px",
      fontWeight: 400,
      color: "#667185",
      textAlign: "left",
      marginBlock: "0px"
    },
    "& h2": {
      fontSize: "14px",
      fontWeight: 400,
      color: "#667185",
      textAlign: "left",
      marginBlock: "0px"
    }
  },
  submitreview: {
    "& p": {
      fontWeight: 500,
      fontSize: "12px",
      color: "#0065FF"
    }
  },
  paddingcont: {
    position: "relative",
    background: "white",
    paddingBlock: "32px",
    "@media (max-width: 590px)": {
      paddingBlock: "14px"
    }
  },
  cardfooter: {
    marginTop: "18px"
  },
  loweritems: {
    height: "50px"
  },
  reload: {
    position: "absolute",
    right: "16px",
    top: "35px",
    cursor: "pointer",
    color: theme.palette.primary.main,
    "& svg": {
      color: theme.palette.primary.main,
      fill: theme.palette.primary.main
    }
  },
  titlebtn: {
    display: "flex",
    marginTop: "16px",
    gap: "10px",
    "@media (max-width: 380px)": {
      flexDirection: "column"
    }
  },
  buttoncountcontainer: {
    marginTop: 15,
    marginBottom: 15
  },
  pickercontainer: {
    maxWidth: "100%",
    border: "1px dashed #D0D5DD",
    maxHeight: 70,
    borderRadius: 10,
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxSizing: "border-box",
    padding: "16px 20px",
    marginBottom: 20,
    marginTop: 7
  },
  picker: {
    opacity: 0,
    width: "100%",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    height: "100%",
    cursor: "pointer",
    position: "absolute"
  },
  uploadflex: {
    display: "flex",
    alignItems: "center",
    gap: 8
  },
  uploadicon: {
    fontSize: 16,
    color: "#101928"
  },
  uploadtitle: {
    fontSize: 16,
    color: "#101928",
    marginBottom: 0,
    marginTop: 0
  },
  uploadsubtitle: {
    color: "#98A2B3",
    fontsize: 16,
    marginBottom: 0,
    marginTop: 0
  },
  remove: {
    color: "red",
    position: "relative",
    alignItems: "center",
    gap: 4,
    padding: "6px 8px",
    boxSizing: "border-box",
    marginLeft: 3,
    zIndex: 50,
    backgroundColor: "white",
    border: "1px solid #98A2B3",
    borderRadius: 4,
    display: "flex",
    fontWeight: "bold"
  },
  camera: {
    color: "white",
    width: "14px!important"
  },
  profilecontainer: {
    backgroundColor: "#F5F6F7",
    width: "100%",
    height: 258,
    marginTop: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 22
  },
  imageviewer: {
    width: "120px",
    height: "120px",
    backgroundColor: "white",
    borderRadius: "50%",
    position: "relative"
  },
  selectcontainer: {
    position: "absolute",
    backgroundColor: theme.palette.primary.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "25px",
    height: "25px",
    bottom: 0,
    right: 0,
    color: "white",
    borderRadius: "50%"
  },
  profilepicker: {
    opacity: 0,
    width: 25,
    height: 25,
    cursor: "pointer",
    position: "absolute"
  },
  previewsubheader: {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
    alignItems: "center",
    marginBottom: "8px",
    "& h5": {
      fontWeight: "500",
      fontSize: "24px",
      color: "#344054",
      marginBlock: "0px"
    },
    "& h4": {
      fontWeight: "500",
      fontSize: "14px",
      marginBlock: "0px",
      color: "#0B0B0B"
    },
    "& h3": {
      fontWeight: "400",
      fontSize: "24px",
      marginBlock: "0px",
      color: "#0B0B0B"
    },
    "& p": {
      fontWeight: "400",
      fontSize: "14px",
      marginBlock: "0px",
      color: "#667185"
    }
  },
  details: {
    backgroundColor: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.07).toRgbString(),
    borderRadius: "14px",
    padding: "16px",
    width: "100%",
    marginBlock: "20px"
  },
  addimages: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    cursor: "pointer",
    heigt: "16px"
  },
  pickimage: {
    position: "absolute",
    width: "100%",
    // height: "100%",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: 1,
    cursor: "pointer",
    opacity: 0
  },
  quillposition: {
    backgroundColor: "white",
    border: "0.84px solid #E7E7E7",
    borderRadius: "4px",
    marginTop: "10px",
    "& .ql-toolbar.ql-snow": {
      border: "none",
      borderBottom: "1px solid #ccc",
      borderRadius: 0
    },
    "& .ql-container.ql-snow": {
      border: "none"
    },
    "& p": {
      marginBottom: "10px"
    }
  },
  // Display Images
  previewGrid: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    gap: "1rem",
    marginBlock: "0.6rem 0.3rem"
  },
  previewItem: {
    position: "relative",
    width: "100px",
    height: "100px"
  },
  previewImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "8px"
  },
  subjectitems: {
    backgroundColor: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.07).toRgbString(),
    borderRadius: "5px",
    fontSize: "14px",
    padding: "14px",
    width: "100%",
    marginBlock: "5px",
    "& h5": {
      marginBlock: "0px",
      fontWeight: "400"
    }
  },
  chatimage: {
    maxWidth: "170px",
    marginBottom: "4px",
    height: "auto"
  },
  chatsection: {
    height: "calc(65vh - 220px)",
    overflowY: "auto"
  },
  viewimg: {
    "& h4": {
      cursor: "pointer"
    }
  },
  starss: {
    fontSize: "24px",
    color: "#BA5A0B",
    cursor: "pointer"
  },
  removeBtn: {
    position: "absolute",
    top: "-10px",
    right: "-10px",
    background: "#ff4d4d",
    color: "#fff",
    padding: "4px 4px 0px 4px",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "0.75rem"
  }
}));
